import axios from 'axios';
import { ICrudGetAction, ICrudGetAllAction, ICrudPutAction, ICrudDeleteAction } from 'react-jhipster';

import { cleanEntity } from '../../../utils/entity-utils';
import { REQUEST, SUCCESS, FAILURE } from '../action-type.util';

import { IEventPoster, defaultValue } from '../../model/event-poster.model';

export const ACTION_TYPES = {
  FETCH_EVENTPOSTER_LIST: 'eventPoster/FETCH_EVENTPOSTER_LIST',
  FETCH_EVENTPOSTER: 'eventPoster/FETCH_EVENTPOSTER',
  CREATE_EVENTPOSTER: 'eventPoster/CREATE_EVENTPOSTER',
  UPDATE_EVENTPOSTER: 'eventPoster/UPDATE_EVENTPOSTER',
  DELETE_EVENTPOSTER: 'eventPoster/DELETE_EVENTPOSTER',
  SET_BLOB: 'eventPoster/SET_BLOB',
  RESET: 'eventPoster/RESET',
};

const initialState = {
  loading: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<IEventPoster>,
  entity: defaultValue,
  updating: false,
  totalItems: 0,
  updateSuccess: false,
};

export type EventPosterState = Readonly<typeof initialState>;

// Reducer

export default (state: EventPosterState = initialState, action): EventPosterState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_EVENTPOSTER_LIST):
    case REQUEST(ACTION_TYPES.FETCH_EVENTPOSTER):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
      };
    case REQUEST(ACTION_TYPES.CREATE_EVENTPOSTER):
    case REQUEST(ACTION_TYPES.UPDATE_EVENTPOSTER):
    case REQUEST(ACTION_TYPES.DELETE_EVENTPOSTER):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true,
      };
    case FAILURE(ACTION_TYPES.FETCH_EVENTPOSTER_LIST):
    case FAILURE(ACTION_TYPES.FETCH_EVENTPOSTER):
    case FAILURE(ACTION_TYPES.CREATE_EVENTPOSTER):
    case FAILURE(ACTION_TYPES.UPDATE_EVENTPOSTER):
    case FAILURE(ACTION_TYPES.DELETE_EVENTPOSTER):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload,
      };
    case SUCCESS(ACTION_TYPES.FETCH_EVENTPOSTER_LIST):
      return {
        ...state,
        loading: false,
        entities: action.payload.data,
        totalItems: parseInt(action.payload.headers['x-total-count'], 10),
      };
    case SUCCESS(ACTION_TYPES.FETCH_EVENTPOSTER):
      return {
        ...state,
        loading: false,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.CREATE_EVENTPOSTER):
    case SUCCESS(ACTION_TYPES.UPDATE_EVENTPOSTER):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.DELETE_EVENTPOSTER):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {},
      };
    case ACTION_TYPES.SET_BLOB: {
      const { name, data, contentType } = action.payload;
      return {
        ...state,
        entity: {
          ...state.entity,
          [name]: data,
          [name + 'ContentType']: contentType,
        },
      };
    }
    case ACTION_TYPES.RESET:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

const apiUrl = 'api/event-posters';

// Actions

export const getEntities: ICrudGetAllAction<IEventPoster> = (page, size, sort) => {
  const requestUrl = `${apiUrl}${sort ? `?page=${page}&size=${size}&sort=${sort}` : ''}`;
  return {
    type: ACTION_TYPES.FETCH_EVENTPOSTER_LIST,
    payload: axios.get<IEventPoster>(`${requestUrl}${sort ? '&' : '?'}cacheBuster=${new Date().getTime()}`),
  };
};

export const getEntity: ICrudGetAction<IEventPoster> = id => {
  const requestUrl = `${apiUrl}/${id}`;
  return {
    type: ACTION_TYPES.FETCH_EVENTPOSTER,
    payload: axios.get<IEventPoster>(requestUrl),
  };
};

export const createEntity: ICrudPutAction<IEventPoster> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_EVENTPOSTER,
    payload: axios.post(apiUrl, cleanEntity(entity)),
  });
  dispatch(getEntities());
  return result;
};

export const updateEntity: ICrudPutAction<IEventPoster> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_EVENTPOSTER,
    payload: axios.put(apiUrl, cleanEntity(entity)),
  });
  return result;
};

export const deleteEntity: ICrudDeleteAction<IEventPoster> = id => async dispatch => {
  const requestUrl = `${apiUrl}/${id}`;
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_EVENTPOSTER,
    payload: axios.delete(requestUrl),
  });
  dispatch(getEntities());
  return result;
};

export const setBlob = (name, data, contentType?) => ({
  type: ACTION_TYPES.SET_BLOB,
  payload: {
    name,
    data,
    contentType,
  },
});

export const reset = () => ({
  type: ACTION_TYPES.RESET,
});
